import type { PickedPhoto } from 'components/PhotoBank/PhotoBank.types'

export enum GooglePhotosStatus {
  AUTHENTICATING = 'authenticating',
  AUTHENTICATED = 'authenticated',
  CREATING_SESSION = 'creating_session',
  CHOOSING_IMAGES = 'choosing_images',
  FETCHING_IMAGES = 'fetching_images',
}

export enum GooglePhotosMediaType {
  PHOTO = 'PHOTO',
  VIDEO = 'VIDEO',
}

export interface PollingConfig {
  pollInterval: string
}

export interface PickingConfig {
  maxItemCount: string
}

export interface GooglePhotosSession {
  id: string
  pickerUri: string
  pollingConfig?: PollingConfig
  expireTime?: string
  pickingConfig?: PickingConfig
  mediaItemsSet?: boolean
  // Legacy field for backward compatibility
  pollingPolicy?: {
    pollInterval: string
  }
}

export interface GooglePhotosMediaItem {
  type: GooglePhotosMediaType
  mediaFile: {
    baseUrl: string
    filename: string
  }
}

export interface GooglePhotosAuthConfig {
  clientId: string
}

export interface GooglePhotosTokenInfo {
  accessToken: string
  expiresAt?: number
}

export interface GooglePhotosPickingOptions {
  singleFileOnly?: boolean
}

export interface GooglePhotosDownloadProgress {
  current: number
  total: number
}

export interface GooglePhotosErrorData {
  [key: string]: any
}

export interface GooglePhotosError {
  code: string
  stage: string
  message: string
  data?: GooglePhotosErrorData
  originalError?: Error | unknown
}

export interface UseGooglePhotosReturn {
  startPhotoPicking: (
    config: GooglePhotosAuthConfig,
    options?: GooglePhotosPickingOptions,
    onAuthSuccess?: () => Promise<void>
  ) => Promise<PickedPhoto[]>
  proceedWithPendingPicking: () => Promise<void>
  setCompletionCallback: (callback: (photos: PickedPhoto[]) => void) => void
  status: GooglePhotosStatus | null
  downloadProgress: GooglePhotosDownloadProgress | null
  error: string | null
  hasToken: boolean
  hasPendingPicking: boolean
  reset: () => void
  logout: () => void
}
